'use strict';

import React, { Component } from 'react';
import uniqid from 'uniqid';
import Layout from 'Layouts/Front';
import Slider from 'Components/Slider';
import EstablishmentPageContent from 'Components/Front/EstablishmentPageContent';
import FullScreenModal from 'Modals/FullScreenModal';
import Image from 'Pure/Image';
import removeGetParameter from 'Functions/removeGetParameter';
import { updateSessionStorage, getSessionStorage } from 'Functions/SessionStorage/frontPage';
import { getUrlParameter } from 'Shared/utilities';
const {
  moment
} = window;
const slider_modal_bemit = ['slider-fullscreen', 'simple'];
export default class FrontEtablishmentPage extends Component {
  state = function () {
    const state = {
      get_params: {
        type: getUrlParameter('type'),
        date: getUrlParameter('date')
      },
      modal: false,
      pathname: document.location.pathname
    };
    const TODAY = moment().format('YYYY-MM-DD');
    const is__date_expired = state.get_params.date ? moment(state.get_params.date).isBefore(TODAY, 'day') : false;
    if (is__date_expired) {
      state.get_params.date = TODAY;
    }

    // enregistre les paramètres get pour les faire persister en cas de
    // reload de la page
    // écrasé en cas de modification du widget par l'utilisateur
    if (state.get_params.type || state.get_params.date) {
      updateSessionStorage({
        pathname: document.location.pathname,
        type: state.get_params.type || 'all',
        date: state.get_params.date || TODAY
      });
    } else
      // récupère d'anciens paramètres get depuis le storage de l'onglet
      {
        const storage_params = getSessionStorage({
          pathname: document.location.pathname
        });
        const is__date_expired = storage_params.date ? moment(storage_params.date).isBefore(TODAY, 'day') : false;
        if (is__date_expired) {
          storage_params.date = TODAY;
          updateSessionStorage({
            pathname: document.location.pathname,
            date: TODAY
          });
        }
        Object.assign(state.get_params, storage_params);
      }
    removeGetParameter('type');
    removeGetParameter('date');
    return state;
  }();
  modal_ref = React.createRef();
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.pathname !== document.location.pathname) {
      component.setState({
        pathname: document.location.pathname
      });
    }
  }
  componentDidUpdate(prev_props, prev_state) {
    const component = this,
      props = this.props,
      state = this.state;
    if (prev_props.pathname && prev_props.pathname !== state.pathname) {
      component.setState({
        pathname: document.location.pathname
      });
    }
  }
  openModal = (e, i) => {
    const component = this,
      props = this.props,
      state = this.state;
    const update = {
      modal: true,
      modal_trg: e?.target,
      modal_i: i || undefined,
      gallery_modal_opened_once: true,
      modal_interacted: false
    };
    if (i !== undefined) {
      window.setTimeout(function () {
        component.setState(update);
      }, 200);
    } else {
      component.setState(update);
    }
  };
  onSliderInteraction = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      modal_interacted: true
    });
  };
  closeModal = e => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      modal: false,
      modal_trg: undefined,
      modal_interacted: false
    });
  };
  handleFetch = ({
    establishment
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    let slider_imgs;
    if (establishment.images?.length > 1) {
      slider_imgs = establishment.images.map(function (image) {
        let data = {
          alt: image.alt || image.title || establishment.name,
          src: image.url,
          id: uniqid()
        };
        return data;
      });
    }
    component.setState({
      slider_imgs: slider_imgs
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    let output = /*#__PURE__*/React.createElement(Layout, props, /*#__PURE__*/React.createElement(EstablishmentPageContent, {
      get_params: state.get_params,
      pathname: state.pathname,
      onFetch: component.handleFetch,
      openGalleryModal: component.openModal
    }), /*#__PURE__*/React.createElement(FullScreenModal, {
      open: state.modal,
      onClose: component.closeModal,
      trigger_src: state.modal_trg,
      bemit: slider_modal_bemit
    }, state.gallery_modal_opened_once && state.slider_imgs ? /*#__PURE__*/React.createElement("div", {
      className: "c-front-page-intro__slider-container"
    }, /*#__PURE__*/React.createElement(Slider, {
      images: state.slider_imgs,
      bemit: ['fill-height'],
      key: state.pathname,
      "with-overlay": true,
      "with-thumbnails": true,
      "with-imgs-title": true,
      initial_img: state.modal_i,
      interacted: state.modal_interacted === true,
      onUserInteraction: component.onSliderInteraction
    })) : state.gallery_modal_opened_once && state.background ? /*#__PURE__*/React.createElement(Image, {
      className: "c-front-page-intro__bg",
      src: state.background,
      alt: 'Illustration ' + state.title
    }) : undefined));
    return output;
  }
}
